module.exports = __webpack_public_path__ + "img/microsoft.f9f93d2a.png";